module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 2.f1a6ff50.wav";